import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom-v5-compat";

import { useClientManager } from "@megaron/react-clients";

export const SalespersonRedirect = () => {
  const { userId } = useParams<{ userId: string }>();

  const navigate = useNavigate();

  const profile = useClientManager("auth")
    .userProfilesQuery()
    .useQuery(
      { legacyUserIds: userId ? [Number(userId)] : [] },
      {
        enabled: !!userId,
      },
    );

  const ownerEmail = profile?.data?.items[0]?.email;

  const regionQuery = useClientManager("crm").regionsQuery().useQuery({ ownerEmail }, { enabled: !!ownerEmail });

  const region = regionQuery.data?.items[0];

  useEffect(() => {
    if (regionQuery.isSuccess || regionQuery.isError) {
      if (region) {
        navigate(`/crm/regions/region/${encodeURIComponent(region.name)}`, { replace: true });
        return;
      }

      navigate("/crm/regions", { replace: true });
    }
  }, [regionQuery.isSuccess, regionQuery.isError, region, navigate]);

  return null;
};
